import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Host service stores behind the management dashboards.
 *
 * `management-metrics` is a read-only aggregate with no addressable rows, so it
 * gets neither local storage nor error notifications — the dashboard tiles
 * surface a failure themselves, in the one place the reader is looking, rather
 * than as a toast that disappears.
 *
 * `sales-targets` is ordinary CRUD. It has no bespoke screen: the
 * auto-generated service view (see generateServiceViewRoutes) is the right
 * amount of UI for one number a month.
 *
 * The QC half of the Plant Operations dashboard reads `qc-metrics`, which
 * @intrasync/quality-control registers itself — see qualityControl.stores.ts.
 */
export const dashboardsStores: ServiceStoreConfig[] = [
  {
    name: "management-metrics",
    options: { enableStorage: false, enableErrorNotifications: false },
  },
  {
    name: "sales-targets",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
];
